import React, {Component} from 'react';
import {message, Popconfirm, Table} from 'antd';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import moment from 'moment';

import util from '@util/index';
import {queryPayablePaidTodo, queryPayableRefund} from '@api/incubator/payable';
import {setWbTabCurrent} from '@store/modules/incubator/wb_tab_current';

class TablePaid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    const { currentShow } = this.props;
    this.incuUuid = this.props.incuUuid;
    this.current = currentShow.billPaidPage || 1;
    this.getPayablePaidTodo();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.incuUuid !== this.props.incuUuid) {
      this.incuUuid = nextProps.incuUuid;
      this.props.incuUuid && (this.current = 1);
      this.getPayablePaidTodo();
    }
  }

  getPayablePaidTodo = () => {
    if (!this.incuUuid) {
      return;
    }
    const { pageSize } = this.props;
    queryPayablePaidTodo({
      incubatorUuid: this.incuUuid || '',
      start: this.current,
      limit: pageSize,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: pageSize || 15,
              current: this.current,
            },
          },
        });
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.getPayablePaidTodo();
    const { currentShow } = this.props;
    currentShow.billPaidPage = pagination.current;
    this.props.dispatch(setWbTabCurrent(currentShow));
  };

  // 退款操作
  confirm = uuid => {
    queryPayableRefund({
      uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.getPayablePaidTodo();
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    const { type } = this.props;
    return [
      {
        title: '账单编号',
        dataIndex: 'no',
        width: 200,
        render: (text, record) => <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>,
      },
      {
        title: '公司名称',
        dataIndex: 'custom',
        width: 200,
      },
      {
        title: '缴费周期',
        dataIndex: 'beginDate',
        width: 200,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        width: 200,
        render: (text, record) => <span>{type[text]}</span>,
      },
      {
        title: '已到期押金待处理金额',
        dataIndex: 'price',
        width: 200,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      },
      {
        title: '合同到期日期',
        dataIndex: 'date',
        width: 200,
        render: (text, record) => {
          const day = Math.floor((Date.now() - text) / 86400000);
          return (
            <div>
              {text ? (
                <span>
                  {moment.unix(text / 1000).format('YYYY-MM-DD')}({day > 0 ? '逾期' : '剩余'}
                  {Math.ceil(Math.abs(day))}
                  天)
                </span>
              ) : null}
            </div>
          );
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        width: 100,
        render: (text, record) => (
          <Popconfirm title="确定做退款操作吗？" onConfirm={() => this.confirm(record.uuid)}>
            <a>退款</a>
          </Popconfirm>
        ),
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
    } = this.state;
    return (
      <Table
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        onChange={this.handleTableChange}
        rowKey="uuid"
      />
    );
  }
}

export default connect(state => ({ currentShow: state.wb_tab_current }))(TablePaid);



// WEBPACK FOOTER //
// ./src/components/incubator/workbench/payables/TablePaid.js